<template>
  <component
    :is="rootTag"
    v-bind="rootAttrs"
    :class="cardClasses"
  >
    <slot>
      <div v-if="text" class="flex w-full min-w-0 flex-col items-start">
        <p class="line-clamp-2 font-sans text-[16px] font-semibold leading-[24px] text-dark">
          {{ text }}
        </p>
      </div>
    </slot>
  </component>
</template>

<script setup>
import { computed } from 'vue';
import { Link } from '@inertiajs/vue3';

const CARD_CLASSES = [
  'bg-white',
  'flex',
  'h-[72px]',
  'items-center',
  'overflow-hidden',
  'px-[16px]',
  'py-[12px]',
  'rounded-[12px]',
  'shadow-[0px_2px_6px_0px_rgba(16,24,40,0.06)]',
  'hover:shadow-[0px_4px_12px_0px_rgba(16,24,40,0.12)]',
  'transition-all',
].join(' ');

const props = defineProps({
  href: {
    type: String,
    default: null,
  },
  text: {
    type: String,
    default: '',
  },
});

const rootTag = computed(() => (props.href ? Link : 'div'));

const rootAttrs = computed(() => (
  props.href ? { href: props.href } : {}
));

const cardClasses = computed(() => CARD_CLASSES);
</script>
